import React from 'react';
import { connect } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import Lbl from '../../../inputs/label.js';
import objectAssign from 'object-assign';

@connect(mapStateToProps)
export default class CenterPanelView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoCallQualityProfiles: props.videoCallQualityProfiles,
      groupForm: props.groupForm,
      postCallSurveOptions: APP.LANGUAGE.PostCallSurvey.Options,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    //THIS EVENT TRIGGERS WHEN THE PARENT UPDATES DATA
  }
  render() {
    var callQuality = '';

    var selectedCallQualityProfile = this.props.videoCallQualityProfiles
      ? this.props.videoCallQualityProfiles.find((x) => x.id == this.props.groupForm.videoCallQualityId)
      : undefined;
    callQuality = selectedCallQualityProfile ? selectedCallQualityProfile.description : '';
    var id = this.props.groupForm.postCallOptionId >= 0 ? this.props.groupForm.postCallOptionId : 0;
    var postCallOptionName = this.state.postCallSurveOptions.find((x) => x.Id == id).Name;

    return (
      <div className="ui form">
        <div className="mrbs">
          <h4 className="mrbs">{APP.LANGUAGE.CreateUpdateGroup.BasicDetailsHeading}</h4>
        </div>

        <div className="  mrts">
          <label className="placeholder-label  no-bold color-placeholder">
            {APP.LANGUAGE.ViewGroup.SelectedGroupLabel}{' '}
          </label>
          <div className="pdls pdtxs">{this.props.groupForm.name}</div>
        </div>

        <div className="mrts">
          <label className="placeholder-label  no-bold color-placeholder">
            {APP.LANGUAGE.ViewGroup.EmailAddressLabel}{' '}
          </label>
          <div className="pdls pdtxs">{this.props.groupForm.email}</div>
        </div>

        <div className="mrbs pdts">
          <h4 className="mrbs">{APP.LANGUAGE.CreateUpdateGroup.MeetingRoomsHeading}</h4>
        </div>

        <div className="mrts">
          <label className="placeholder-label  no-bold color-placeholder">
            {APP.LANGUAGE.ViewGroup.CallQualityLabel}{' '}
          </label>
          <div className="pdls pdtxs">{callQuality}</div>
        </div>

        <div className="mrts" data-show={postCallOptionName ? true : false}>
          <label className="placeholder-label  no-bold color-placeholder">
            {APP.LANGUAGE.ViewGroup.SelectedSurveyOptionLabel}{' '}
          </label>
          <div className="pdls pdtxs">{postCallOptionName}</div>
        </div>

        <div
          className="mrts"
          data-show={postCallOptionName && this.props.groupForm.postCallOptionId == 1 ? true : false}
        >
          <label className="placeholder-label  no-bold color-placeholder">
            {APP.LANGUAGE.ViewGroup.SameInformationSurvePageLabel}{' '}
          </label>
          <div className="pdls pdtxs">{this.props.groupForm.postCallUrl}</div>
        </div>

        <div
          className="mrts"
          data-show={postCallOptionName && this.props.groupForm.postCallOptionId == 2 ? true : false}
        >
          <label className="placeholder-label  no-bold color-placeholder">
            {APP.LANGUAGE.ViewGroup.DifferentSurveyGroupMemberUrl}{' '}
          </label>
          <div className="pdls pdtxs">{this.props.groupForm.providerUrl}</div>
        </div>

        <div
          className="mrts"
          data-show={postCallOptionName && this.props.groupForm.postCallOptionId == 2 ? true : false}
        >
          <label className="placeholder-label  no-bold color-placeholder">
            {APP.LANGUAGE.ViewGroup.DifferentSurveyOtherParticipant}{' '}
          </label>
          <div className="pdls pdtxs">{this.props.groupForm.callerGuestUrl}</div>
        </div>

        <div className="mrts" data-show={this.props.groupForm.purgeCallerDetails == false}>
          <label className="pdls pdtxs">{APP.LANGUAGE.ViewGroup.DontPurgeCallDetailsLabel} </label>
        </div>
        <div className="mrts" data-show={this.props.groupForm.purgeCallerDetails == true}>
          <label className="pdls pdtxs">{APP.LANGUAGE.ViewGroup.PurgeCallDetailsLabel} </label>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    groupForm: state.groupsReducer.groupForm,
    videoCallQualityProfiles: state.portalSettingReducer.portalSetting.videoCallQualityProfiles,
  };
}
